<template lang="pug">
v-container(fluid :class="loading ? 'tw-opacity-50' : ''" class="tw-border tw-rounded-md tw-border-gray-lighten-3 tw-mb-2 mt-0")
  v-row(no-gutters)
    v-col
      router-link(class="tw-font-medium text-link" :to="{ name: 'settingsTeamItem', params: { id: item.id } }")
        v-row(no-gutters)
          v-col(cols="auto" class="tw-self-center")
            v-img(:src="item.profile_photo_url" contain class="tw-rounded" width="50px")
          v-col(class="tw-mx-2 tw-overflow-hidden" cols="8" xl="")
            v-row(no-gutters)
              v-col
                span(class=" tw-text-lg mb-0 pb-0") {{ item.name }}
            v-row(no-gutters)
              v-col
                span(class="text-subtitle-2") {{ item.email }}
    v-col(cols="auto" class="tw-self-center")
      v-menu(
        bottom
        left
        nudge-bottom="35"
        nudge-left="5"
        ma-0
        pa-0
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            :ripple="false"
            depressed
            v-on="on"
            v-bind="attrs"
            width="10px"
            max-width="10"
            min-width="10"
            min-height="10"
            max-height="30"
            :disabled="loading"
            class="tw-border-gray-lighten-1 tw-p-0 tw-m-0"
          )
            v-icon(color="blue-grey darken-1 tw-p-0 tw-m-0") mdi-dots-horizontal
        v-list(dark dense min-width="120px" style="background-color: #424242")
          v-list-item(class="tw-p-0")
            v-btn(
              small
              left
              tile
              block
              pa-0
              ma-0
              text
              @click="confirmDialog = true"
              class="tw-items-center tw-justify-start tw-my-1"
            ) {{ $t('Common.delete') }}
          v-list-item(class="tw-p-0")
            v-btn(
              small
              left
              tile
              block
              pa-0
              ma-0
              text
              class=" tw-items-center tw-justify-start tw-my-1"
            ) {{ $t('Common.resetPassword') }}
  v-dialog(v-model="confirmDialog" max-width="35%" hide-overlay class="tw-ml-32")
    div(class="tw-bg-white py-1 px-3")
      v-row(no-gutters class="pt-2")
        v-col
          span(class=" tw-text-2xl text-secondary tw-font-bold ") Delete User
      v-row(justify="center")
        v-col(cols="auto")
          span Are you sure you want to delete this user?
      v-row(justify="end")
        v-col(cols="auto")
          v-btn(
            x-small
            text
            elevation="0"
            :ripple="false"
            @click="confirmDialog = false"
          )
            span(class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") CANCEL
        v-col(cols="auto")
          v-btn(depressed :loading="loading" @click="destroy" color="red darken-1")
            span(class="tw-font-bold") DELETE
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
      confirmDialog: false,
    };
  },
  methods: {
    destroy() {
      this.loading = true;
      this.$store
        .dispatch('team/deleteMember', this.item.id)
        .then((response) => {
          this.$store
            .dispatch('team/getMembers')
            .then((response) => {
              this.loading = false;
              this.confirmDialog = false;
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
